export default "/images/vendor/flag-icons/flags/1x1/cefta.svg?4247899e6d860ac788cd8280e564f04b";